import { Controller } from "@hotwired/stimulus"

// Enter submits the note; Shift+Enter inserts a newline. Also exposes submit()
// for blur-to-save fields (e.g. group labels).
export default class extends Controller {
  maybeSubmit(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.form?.requestSubmit()
    }
  }

  // Blur fires after Enter has already saved, so skip when nothing changed:
  // otherwise every named group costs a second PATCH and a board-wide
  // broadcast. Idiomorph syncs the value attribute, so defaultValue tracks
  // what the server last rendered. A <select> has no defaultValue, so the
  // change-to-save link picker still submits.
  submit() {
    if (this.element.value === this.element.defaultValue) return

    this.element.form?.requestSubmit()
  }
}
